export var cibMacys = ["32 32", "<path d='M16.021 0.833l-3.766 11.557h-12.255l9.927 7.177-3.76 11.568 9.833-7.156 9.896 7.193-3.781-11.62 9.885-7.161h-12.214l-3.766-11.563z'/>"];
